import Actions from '../../action'
const initialState = {
    isLoading:false,
    error:false
}
export default (state = initialState, action = {}) => {
    switch (action.type) {
        case Actions.ADD_ADDRESS: {
            return {
                ...state,
                isLoading: true,
            };
        }
        case Actions.ADD_ADDRESS_SUCCESS: {

            return {
                ...state,
                isLoading: false,
                error: false
            };
        }
        case Actions.ADD_ADDRESS_FAILURE: {
            return {
                ...state,
                isLoading: false,
                error: action.error,
            };
        }
        default:
            return state;
    }
};
